import React, { useEffect, useRef } from 'react'
import { Helmet } from 'react-helmet-async'
import '../css/FilmBudgetBreakdown.css'
import '../css/AiToolResultsPage.css'
import FilmBudgetBreakdownResultsView from '../components/filmBudget/FilmBudgetBreakdownResultsView'
import ProductionToolsHeader from '../components/productionTools/ProductionToolsHeader'
import AiToolResultsHero from '../components/productionTools/AiToolResultsHero'
import AiToolResultsLoading from '../components/productionTools/AiToolResultsLoading'
import { useAiToolResultsPage } from '../hooks/useAiToolResultsPage'
import { AI_TOOL_TYPES } from '../utils/aiTool/payment'
import { STREAM_MESSAGES } from '../utils/filmBudget/constants'

const FilmBudgetBreakdownResultsPage = () => {
  const { loading, error, streamMsg, resultState, resetToTool } =
    useAiToolResultsPage(AI_TOOL_TYPES.BUDGET_BREAKDOWN, STREAM_MESSAGES)

  const heroMeta = resultState?.inputs?.projTitle
    ? `Project: ${resultState.inputs.projTitle}`
    : null
  const resultsRef = useRef(null)

  useEffect(() => {
    if (resultState && resultsRef.current) {
      resultsRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }, [resultState])

  return (
    <div className="production-tools-theme film-budget-page ai-tool-results-page">
      <Helmet>
        <title>Budget Breakdown Results | PitchBlu</title>
        <link
          href="https://fonts.googleapis.com/css2?family=Anton&family=Bricolage+Grotesque:opsz,wght@12..96,200..800&display=swap"
          rel="stylesheet"
        />
      </Helmet>

      <ProductionToolsHeader badge="Budget Intelligence" />

      <AiToolResultsHero
        toolType={AI_TOOL_TYPES.BUDGET_BREAKDOWN}
        meta={heroMeta}
        loading={loading}
      />

      {loading && (
        <AiToolResultsLoading
          label="● AI is building your budget breakdown"
          streamMsg={streamMsg}
        />
      )}

      {!loading && error && (
        <div className="ai-tool-results-error wrap">
          <div className="err on">{error}</div>
          <div style={{ marginTop: 16 }}>
            <button type="button" className="btn-new" onClick={resetToTool}>
              Back to Budget Breakdown
            </button>
          </div>
        </div>
      )}

      {!loading && resultState && (
        <div ref={resultsRef}>
          <FilmBudgetBreakdownResultsView
            budget={resultState.budget}
            inputs={resultState.inputs}
            investorStmt={resultState.investorStmt}
            intelItems={resultState.intelItems}
            aiContent={resultState.aiContent}
            market={resultState.market}
            onReset={resetToTool}
          />
        </div>
      )}
    </div>
  )
}

export default FilmBudgetBreakdownResultsPage
